/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AppPermissionsEnum,
  ChangePasswordInput,
  ConfirmEmailRequestDto,
  CurrentUserProfileDto,
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100NotFoundException,
  ErrorResponseOfPtw100UnauthorizedException,
  PtwSessionDto,
  ResetPasswordRequestDto,
  ResultDtoOfBoolean,
  ValidateTokenRequestDto,
} from '../models/index';
import {
    AppPermissionsEnumFromJSON,
    AppPermissionsEnumToJSON,
    ChangePasswordInputFromJSON,
    ChangePasswordInputToJSON,
    ConfirmEmailRequestDtoFromJSON,
    ConfirmEmailRequestDtoToJSON,
    CurrentUserProfileDtoFromJSON,
    CurrentUserProfileDtoToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100NotFoundExceptionFromJSON,
    ErrorResponseOfPtw100NotFoundExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    PtwSessionDtoFromJSON,
    PtwSessionDtoToJSON,
    ResetPasswordRequestDtoFromJSON,
    ResetPasswordRequestDtoToJSON,
    ResultDtoOfBooleanFromJSON,
    ResultDtoOfBooleanToJSON,
    ValidateTokenRequestDtoFromJSON,
    ValidateTokenRequestDtoToJSON,
} from '../models/index';

export interface ChangePasswordRequest {
    changePasswordInput?: ChangePasswordInput;
}

export interface ConfirmActivationRequest {
    confirmEmailRequestDto?: ConfirmEmailRequestDto;
}

export interface ResetPasswordRequest {
    resetPasswordRequestDto?: ResetPasswordRequestDto;
}

export interface SendResetPasswordLinkRequest {
    email: string;
}

export interface UpdateCurrentUserProfileRequest {
    currentUserProfileDto?: CurrentUserProfileDto;
}

export interface ValidateActivateUserTokenRequest {
    validateTokenRequestDto?: ValidateTokenRequestDto;
}

export interface ValidateResetPasswordTokenRequest {
    validateTokenRequestDto?: ValidateTokenRequestDto;
}

/**
 * 
 */
export class AccountApi extends runtime.BaseAPI {

    /**
     * Accepts the EULA for the current user.
     */
    async acceptEulaRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/account/accept-eula`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Accepts the EULA for the current user.
     */
     async acceptEula(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<AccountApi['acceptEulaRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.acceptEulaRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Changes the password of user of current session
     */
    async changePasswordRaw(requestParameters: ChangePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/account/change-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordInputToJSON(requestParameters['changePasswordInput']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Changes the password of user of current session
     */
     async changePassword(requestParameters: ChangePasswordRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<AccountApi['changePasswordRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.changePasswordRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * confirms the activation of user
     */
    async confirmActivationRaw(requestParameters: ConfirmActivationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/account/confirm-activation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfirmEmailRequestDtoToJSON(requestParameters['confirmEmailRequestDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * confirms the activation of user
     */
     async confirmActivation(requestParameters: ConfirmActivationRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<AccountApi['confirmActivationRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.confirmActivationRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the profile of user of current session
     */
    async getCurrentUserProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/account/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => CurrentUserProfileDtoFromJSON(jsonValue), "CurrentUserProfileDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => CurrentUserProfileDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns the profile of user of current session
     */
     async getCurrentUserProfile(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<AccountApi['getCurrentUserProfileRaw']>>, CurrentUserProfileDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = CurrentUserProfileDto;

         const response = this.getCurrentUserProfileRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns session-information of user of current session
     */
    async getSessionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/account/session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => PtwSessionDtoFromJSON(jsonValue), "PtwSessionDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => PtwSessionDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns session-information of user of current session
     */
     async getSession(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<AccountApi['getSessionRaw']>>, PtwSessionDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = PtwSessionDto;

         const response = this.getSessionRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the permissions of user of current session
     */
    async getUsersPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/account/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppPermissionsEnumFromJSON), "AppPermissionsEnum" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppPermissionsEnumFromJSON));
					}
				}
				// -- Responses
    }

    /**
     * Returns the permissions of user of current session
     */
     async getUsersPermissions(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<AccountApi['getUsersPermissionsRaw']>>, Array<AppPermissionsEnum>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<AppPermissionsEnum>;

         const response = this.getUsersPermissionsRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Resets the password
     */
    async resetPasswordRaw(requestParameters: ResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/account/reset-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordRequestDtoToJSON(requestParameters['resetPasswordRequestDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoOfBooleanFromJSON(jsonValue), "ResultDtoOfBoolean" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoOfBooleanFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Resets the password
     */
     async resetPassword(requestParameters: ResetPasswordRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<AccountApi['resetPasswordRaw']>>, ResultDtoOfBoolean>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ResultDtoOfBoolean;

         const response = this.resetPasswordRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Sends a reset password link to email
     */
    async sendResetPasswordLinkRaw(requestParameters: SendResetPasswordLinkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling sendResetPasswordLink().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/account/reset-password/{email}`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Sends a reset password link to email
     */
     async sendResetPasswordLink(requestParameters: SendResetPasswordLinkRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<AccountApi['sendResetPasswordLinkRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.sendResetPasswordLinkRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Updates the profile of user of current session
     */
    async updateCurrentUserProfileRaw(requestParameters: UpdateCurrentUserProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/account/profile`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CurrentUserProfileDtoToJSON(requestParameters['currentUserProfileDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => CurrentUserProfileDtoFromJSON(jsonValue), "CurrentUserProfileDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => CurrentUserProfileDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Updates the profile of user of current session
     */
     async updateCurrentUserProfile(requestParameters: UpdateCurrentUserProfileRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<AccountApi['updateCurrentUserProfileRaw']>>, CurrentUserProfileDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = CurrentUserProfileDto;

         const response = this.updateCurrentUserProfileRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Validates the confirm email token
     */
    async validateActivateUserTokenRaw(requestParameters: ValidateActivateUserTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/account/activate-user/validate-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateTokenRequestDtoToJSON(requestParameters['validateTokenRequestDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoOfBooleanFromJSON(jsonValue), "ResultDtoOfBoolean" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoOfBooleanFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Validates the confirm email token
     */
     async validateActivateUserToken(requestParameters: ValidateActivateUserTokenRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<AccountApi['validateActivateUserTokenRaw']>>, ResultDtoOfBoolean>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ResultDtoOfBoolean;

         const response = this.validateActivateUserTokenRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Validates the reset password token
     */
    async validateResetPasswordTokenRaw(requestParameters: ValidateResetPasswordTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/account/reset-password/validate-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateTokenRequestDtoToJSON(requestParameters['validateTokenRequestDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoOfBooleanFromJSON(jsonValue), "ResultDtoOfBoolean" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoOfBooleanFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Validates the reset password token
     */
     async validateResetPasswordToken(requestParameters: ValidateResetPasswordTokenRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<AccountApi['validateResetPasswordTokenRaw']>>, ResultDtoOfBoolean>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ResultDtoOfBoolean;

         const response = this.validateResetPasswordTokenRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
